import { useQuery, useTRPC } from "@luckymenu/api-client/react";

/**
 * The active restaurant, the caller's role and permissions, from
 * `staff.tenancy.getCurrent`. Cached; the restaurant gate has loaded it
 * before any screen inside the shell renders.
 */
export function useCurrentMembership() {
	const trpc = useTRPC();
	return useQuery(trpc.staff.tenancy.getCurrent.queryOptions());
}
